import { IApi } from '../../api'
import { IClientBannerPayload } from '../../api/clientBanner'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'clientBanners'

export const [
  LIST_CLIENT_BANNERS_REQUEST,
  LIST_CLIENT_BANNERS_SUCCESS,
  LIST_CLIENT_BANNERS_FAILURE,
] = createRequestTypes(prefix, 'LIST_CLIENT_BANNERS')

export const [
  CREATE_CLIENT_BANNER_REQUEST,
  CREATE_CLIENT_BANNER_SUCCESS,
  CREATE_CLIENT_BANNER_FAILURE,
] = createRequestTypes(prefix, 'CREATE_CLIENT_BANNER')

export const [
  UPDATE_CLIENT_BANNER_REQUEST,
  UPDATE_CLIENT_BANNER_SUCCESS,
  UPDATE_CLIENT_BANNER_FAILURE,
] = createRequestTypes(prefix, 'UPDATE_CLIENT_BANNER')

export const [
  EXPIRE_CLIENT_BANNER_REQUEST,
  EXPIRE_CLIENT_BANNER_SUCCESS,
  EXPIRE_CLIENT_BANNER_FAILURE,
] = createRequestTypes(prefix, 'EXPIRE_CLIENT_BANNER')

export const [
  DELETE_CLIENT_BANNER_REQUEST,
  DELETE_CLIENT_BANNER_SUCCESS,
  DELETE_CLIENT_BANNER_FAILURE,
] = createRequestTypes(prefix, 'DELETE_CLIENT_BANNER')

export const listClientBanners = createAction((params?: object) => ({
  type: [LIST_CLIENT_BANNERS_REQUEST, LIST_CLIENT_BANNERS_SUCCESS, LIST_CLIENT_BANNERS_FAILURE] as [
    string,
    string,
    string,
  ],
  promise: (api: IApi) => api.clientBanner.list(params),
  params,
}))

export const createClientBanner = createAction((data: IClientBannerPayload) => ({
  type: [
    CREATE_CLIENT_BANNER_REQUEST,
    CREATE_CLIENT_BANNER_SUCCESS,
    CREATE_CLIENT_BANNER_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.clientBanner.create(data),
}))

export const updateClientBanner = createAction((id: string, data: IClientBannerPayload) => ({
  type: [
    UPDATE_CLIENT_BANNER_REQUEST,
    UPDATE_CLIENT_BANNER_SUCCESS,
    UPDATE_CLIENT_BANNER_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.clientBanner.update(id, data),
}))

export const expireClientBanner = createAction((id: string) => ({
  type: [
    EXPIRE_CLIENT_BANNER_REQUEST,
    EXPIRE_CLIENT_BANNER_SUCCESS,
    EXPIRE_CLIENT_BANNER_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.clientBanner.expire(id),
}))

export const deleteClientBanner = createAction((id: string) => ({
  type: [
    DELETE_CLIENT_BANNER_REQUEST,
    DELETE_CLIENT_BANNER_SUCCESS,
    DELETE_CLIENT_BANNER_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.clientBanner.delete(id),
}))
